import React, { useEffect, useState } from 'react';
import { Loader } from 'react-feather';
import ManageTable from '../../../Manage/ManageTable';
import PopupModal from '../../../Manage/PopupModal';

const SavedJobs = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [modal, setModal] = useState(false);
  const handleModal = () => setModal(!modal);

  const jobData = [
    {
      jobTitle: "Product Designer",
      location: "Islamabad, Pakistan",
      datePosted: "30/04/2024",
      dateSaved: "30/04/2024",
      action: "Action"
    },
    {
      jobTitle: "Marketing Spec.",
      location: "Islamabad, Pakistan",
      datePosted: "30/04/2024",
      dateSaved: "30/04/2024",
      action: "Action"
    },
    {
      jobTitle: "Software Engineer",
      location: "Islamabad, Pakistan",
      datePosted: "30/04/2024",
      dateSaved: "30/04/2024",
      action: "Action"
    }
  ];

  useEffect(() => {
    // Simulate fetching data
    setTableData(jobData);
    setLoading(false);
  }, []);

  const columns = [
    {
      name: "Job Title",
      cell: (row) => <span title={row.jobTitle} className="ellipsis">{row.jobTitle}</span>,
      selector: (row) => row.jobTitle,
      sortable: true,
    },
    {
      name: "Location",
      cell: (row) => <span title={row.location} className="ellipsis">{row.location}</span>,
      selector: (row) => row.location,
      sortable: true,
    },
    {
      name: "Date Posted",
      cell: (row) => <span title={row.datePosted} className="ellipsis">{row.datePosted}</span>,
      selector: (row) => row.datePosted,
      sortable: true,
    },
    {
      name: "Date Saved",
      cell: (row) => <span title={row.dateSaved} className="ellipsis">{row.dateSaved}</span>,
      selector: (row) => row.dateSaved,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <span title={row.action} className="ellipsis">
          <div style={{ cursor: 'pointer' }} onClick={() => clickHandler(row.action)}>{row.action}</div>
        </span>
      ),
      selector: (row) => row.action,
      sortable: true,
    },
  ];

  const [openName, setOpenName] = useState('');

  const clickHandler = (name) => {
    setModal(true);
    setOpenName(name);
  };

  return (
    <>
      <div>
        {loading ? <Loader /> :
          <ManageTable
            name={'Saved Jobs'}
            columns={columns}
            setTableData={setTableData}
            tableData={tableData}
          />
        }
      </div>

      <PopupModal
        company_id={''}
        open={modal}
        setModal={setModal}
        handleModal={handleModal}
        name={openName}
        tableData={''}
        setTableData={''}
      />
    </>
  );
};

export default SavedJobs;
